import React, { useState, useEffect, useRef } from 'react';
import {
    formatMoneda, formatoMonto, validaMonto
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';



// import axios from 'axios';
import useTableFijo from '../useTableFijo';
import { AgregarOrdenPago } from './modalIncluirOrdenPagos';
import moment from 'moment';



function TablaListEgresos(props) {

    // let op = require('../../../src/modulos/datos');
    // let token = localStorage.getItem('jwtToken');
    const espiritu = JSON.parse(localStorage.getItem("espiritu"));

    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N°', textAlign: 'center' },
        /*{ id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Factura', textAlign: 'center' },*/
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Fecha', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto Orden', textAlign: 'center' },
        { id: '5', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Abonado', textAlign: 'center' },
        { id: '6', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Retenido', textAlign: 'center' },
        { id: '7', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto Amortizado', textAlign: 'center' },
        { id: '8', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto a Pagar', textAlign: 'center' },
        { id: '9', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: <i class="fas fa-ellipsis-h" />, textAlign: 'center' },
    ]

    //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false : true;
    const norden = true;

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [desde, setDesde] = useState(0);
    const [records, setRecords] = useState([]);
    const [datosOrd, setDatosOrd] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    // const txtMonto = useRef([]);
    // const txtMontoTotal = useRef();



    const blanquearCampos = () => {
        setMostrar(false);
        setTitulo('');
        setMsg('');
    }

    const {
        TblContainer,
        TblHead,
        // TblPagination,
        recordsAfterPagingAndSorting
    } = useTableFijo(records, headCells, filterFn, 220);


    const handleCloseSi = () => {

        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        var idcta = "0";
        var data = [];
        if (desde === 0) {
            idcta = datosOrd[0].idctaban;
            data = [...records];

            for (let i = 0; i < datosOrd.length; i++) {

                data.push({
                    numordenpago: datosOrd[i].numordenpago,
                    razonsocial: datosOrd[i].razonsocial,
                    concepto: datosOrd[i].concepto,
                    idproveedor: datosOrd[i].idproveedor,
                    idordenpago: datosOrd[i].idordenpago,
                    fecha: datosOrd[i].fecha,
                    observaciones: datosOrd[i].observaciones,
                    montoorden: datosOrd[i].montoorden,
                    montoamortizado: datosOrd[i].montoamortizado,
                    montoabonado: datosOrd[i].montoabonado,
                    montoretenido: datosOrd[i].montoretenido,
                    montopagar: datosOrd[i].montopagar,
                    tipoorden: datosOrd[i].tipoorden,
                    claseorden: datosOrd[i].claseorden,
                    idcuentabancaria: datosOrd[i].idcuentabancaria,

                });

            }
        } else if (desde === 1) {
            var datos = [...records];
            //var elementos = [];

            for (let i = 0; i < datos.length; i++) {

                if (datosOrd.idordenpago !== datos[i].idordenpago) {
                    data.push(datos[i]);
                }

            }


            //setRecords(elementos);
            //props.data(elementos, "0");
        }


        setRecords(data);
        props.data(data, idcta, operacion);



    };

    const cerrarModalActualizar = () => {

        setMostrar5(false);
    }


    const opciones = (ope, index) => (event) => {

        event.preventDefault();
        //blanquearCampos();
        setOperacion(ope);
        if (ope === 1) {
            let sigue = true;
            for (let i = 0; i < records.length; i++) {
                if (parseFloat(records[i].montoorden) - parseFloat(records[i].montoretenido) > parseFloat(records[i].montopagar)) {
                    sigue = false;
                    break
                }
                //const element = array[i];
            }
            if (!sigue) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se puede agregar otra Orden de Pago porque existe un abono a una Orden de Pago', icono: 'error' });
            } else {
                setMostrar5(true);
                setOperacion(1);
                blanquearCampos()
            }


        } if (ope === 3) {

        }

    }

    const handleAceptarDatos = (datos) => {
        setMostrar5(false);

        //console.log(datos);
        let idcta = "0";
        let sigue = true;
        if (props.idcuentabancaria === '') {
            if (parseInt(datos[0].idcuentabancaria) > 0) {
                idcta = datos[0].idcuentabancaria;
                /*txtCodCuenta.setText(res.get(14).toString().trim());
                evt.keyCode = SWT.CR;
                txtCodCuenta.notifyListeners(SWT.KeyUp, evt);
                txtCodCuenta.setEnabled(false);
                btnCuenta.setEnabled(false);*/
            }

        } else {
            if (parseInt(props.idcuentabancaria) !== parseInt(datos[0].idcuentabancaria)) {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Orden de Pago Tiene una Cuenta Bancaria Diferente', icono: 'error' });
                sigue = false;
                return;
            }
        }
        let clase = records.length > 0 ? records[records.length - 1].claseorden : datos[0].claseorden
        if (clase !== "0") {
            if (idcta !== "0") {
                if (parseInt(props.idcuentabancaria) !== parseInt(datos[0].idcuentabancaria)) {
                    setDatosOrd(datos);
                    setDesde(0);
                    setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Esta Orden de Pago es distinta a las demas \n Desea Agregarla?', icono: 'confirmacion' });
                    sigue = false;
                }
            }
        }
        if (sigue) {
            let data = [...records];

            for (let i = 0; i < datos.length; i++) {

                data.push({
                    numordenpago: datos[i].numordenpago,
                    razonsocial: datos[i].razonsocial,
                    concepto: datos[i].concepto,
                    idproveedor: datos[i].idproveedor,
                    idordenpago: datos[i].idordenpago,
                    fecha: datos[i].fechaorden,
                    observaciones: datos[i].observaciones,
                    montoorden: datos[i].montoorden,
                    montoamortizado: datos[i].montoamortizado,
                    montoabonado: datos[i].montoabonado,
                    montoretenido: datos[i].montoretenido,
                    montopagar: datos[i].montopagar,
                    tipoorden: datos[i].tipoorden,
                    claseorden: datos[i].claseorden,
                    idcuentabancaria: datos[i].idcuentabancaria,

                });

            }

            setRecords(data);
            props.data(data, idcta, operacion);
        }

    }

    useEffect(() => {
        //blanquearCampos();
        //setRecords([]);
        if (props.datarecords.length > 0) {

            var data = [...props.datarecords];
            var datos = [];

            for (let i = 0; i < data.length; i++) {

                datos.push({
                    numordenpago: data[i].numordenpago,
                    razonsocial: data[i].razonsocial,
                    concepto: data[i].concepto,
                    idproveedor: data[i].idproveedor,
                    idordenpago: data[i].idordenpago,
                    fecha: data[i].fecha,
                    observaciones: data[i].observaciones,
                    montoorden: data[i].montoorden,
                    montoamortizado: data[i].montoamortizado,
                    montoabonado: data[i].montoabonado,
                    montoretenido: data[i].montoretenido,
                    montopagar: data[i].montopagar,
                    tipoorden: data[i].tipoorden,
                    claseorden: data[i].claseorden,
                    idcuentabancaria: data[i].idcuentabancaria,

                });

            }

            console.log(datos);
            setRecords(datos);
        } else {
            setRecords([]);
        }

    }, [props.datarecords]);

    useEffect(() => {


    }, [props.idcuentabancaria]);

    const eliminarOrdenPago = (item) => (e) => {
        e.preventDefault();
        setOperacion(3);
        setDesde(1);
        setDatosOrd(item);
        setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Esta seguro de eliminar el registro?', icono: 'confirmacion' });

    }

    return (
        <div className='col-12 p-0 m-0'>
            <AgregarOrdenPago
                show={mostrar5}
                operacion={operacion}
                onDatos={handleAceptarDatos}
                onHideCancela={cerrarModalActualizar}
                idproveedor={props.idproveedor}
                ordenesp={records}
            />
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })}
                onHideSi={handleCloseSi} />

            <Dimmer active={activate} inverted>

            </Dimmer>
            <div className="col-12 m-0 p-0 d-flex align-items-center justify-content-between">
                <div className="col-11 m-0 p-0">
                    <TblContainer container={{ height: 120 }}>
                        <TblHead />
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item + item.idcuenta} className="table-bordered" style={{ padding: "0", height: '40px' }}>
                                        <td className='text-center' style={{ fontSize: "10px", width: "50px" }}>{norden ? item.numordenpago : item.idordenpago}</td>
                                        {/*<td className='text-center' style={{ fontSize: "10px", width: '80px' }}>{item.concepto}</td>*/}
                                        <td className='text-center' style={{ fontSize: "10px", width: '80px' }}>{moment.utc(item.fecha).format('DD/MM/YYYY')}</td>
                                        <td className='text-right' style={{ fontSize: "10px", width: '80px' }}>{formatMoneda(item.montoorden.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td className='text-right' style={{ fontSize: "10px", width: '80px' }}>{formatMoneda(item.montoabonado.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td className='text-right' style={{ fontSize: "10px", width: '80px' }}>{formatMoneda(item.montoretenido.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td className='text-right' style={{ fontSize: "10px", width: '80px' }}>{formatMoneda(item.montoamortizado.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td className='text-right' style={{ fontSize: "10px", width: '80px' }}>{formatMoneda(item.montopagar.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td ssName='align-baseline' style={{ fontSize: "10px", textAlign: "center", width: "60px" }}>
                                            <button onClick={eliminarOrdenPago(item)} disabled={props.operacion === 4 || props.operacion === 2 || props.operacion === 3 ? true : false} className="btn btn-danger btn-sm rounded-circle"><i className="fa fa-trash-alt"></i></button>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </TblContainer>
                    {/* <TblPagination /> */}
                </div>
                <div className='col-1 p-0 d-flex justify-content-center align-items-center'>
                    <button onClick={opciones(1, '')}
                        disabled={props.habibot}
                        className="btn btn-primary btn-sm rounded">
                        <i className="fas fa-plus"></i>
                    </button>
                </div>

            </div>
        </div>
    );
}

export default TablaListEgresos;
